import { CSSProperties, forwardRef } from 'react';

type AutomatedClinicianIframeProps = {
  className?: string;
  style?: CSSProperties;
  allow?: string;
};

/**
 * Renders the invisible automated clinician iframe.
 */
export const AutomatedClinicianIframe = forwardRef<HTMLIFrameElement, AutomatedClinicianIframeProps>(
  ({ className, style, allow }, ref) => (
    <iframe
      ref={ref}
      title="Automated Clinician"
      src="/automated-clinician-dev"
      allow={allow ?? 'camera; microphone; autoplay'}
      className={className}
      style={{
        width: 0,
        height: 0,
        border: 0,
        opacity: 0,
        position: 'absolute',
        pointerEvents: 'none',
        ...style
      }}
    />
  )
);

AutomatedClinicianIframe.displayName = 'AutomatedClinicianIframe';
